jQuery( document ).ready(function() {
    //Document Ready Start
    
        //** Gravity Forms **//
        
        jQuery('.gform_footer').addClass('primary-btn');
        jQuery('.gform_button').addClass('fl-button');
        
        //** Testimonial Slider **//
        
        if (jQuery(".testimonial-slider")[0]){
            jQuery(".testimonial-slider .fl-slide-title").each(function() {
              jQuery(this).closest(".fl-slide").find('.fl-slide-photo').append(this);
            });
        }
        //**3 Buttons Above 3 Cards with CTA**//
      
        if (jQuery(".three-col-btns")[0]){
            jQuery('.three-col-btns .fl-button-group-buttons>div:first-child a').addClass('active');
            
            jQuery(".three-col-btns .fl-button").click(function(){
                
                var show_tab = jQuery(this).attr('href');
                
                if( show_tab != "#both" ){
                    jQuery(show_tab).show();
                    jQuery(show_tab).siblings('.three-col-card-row').hide();
                    jQuery('#white-wine').removeClass('hide-bg');
                }else{
                    jQuery('.three-col-card-row').show();
                    jQuery('#white-wine').addClass('hide-bg');
                    
                }
                
                if(!jQuery(this).hasClass('active')){
                    jQuery(this).addClass('active');
                }
                    
                jQuery(this).parents('.fl-button-group-button').siblings().find('.fl-button').removeClass('active');
                
            });
        }

        /*
            ---- Join the Club Product Selector ----
            Connects the columns and active items with href attr -> by adding a '#'
            In href the id is intered without #, in order to avoid scrolling.
        */

        if (jQuery("#jointheclub-selector").length > 0) {
            const main = '#jointheclub-selector';
            const firstHeight = jQuery(jQuery(jQuery(main + ' .jtc-content-col').first().children()[0]).children()[0]).outerHeight();
            const secondHeight = jQuery(jQuery(main + ' .jtc-content-col').first().children()[0]).outerHeight();
            const finalHeight = jQuery(jQuery(main + ' .jtc-content-col').first()).outerHeight();
        
            if (window.matchMedia('(min-width: 1046px)').matches) {
                jQuery(main + ' #progress').css('height', firstHeight + 'px');
            }
        
            jQuery(main + ' .toggle-jtc .fl-button').on('click', function (e) {
                e.preventDefault();
                let activeEl = '#' + jQuery(this).attr('href').replace(/^https?:\/\//, '');
                let activeImg = '#' + jQuery(this).attr('href').replace(/^https?:\/\//, '') + '-image';
        
                if (window.matchMedia('(min-width: 1046px)').matches) {
                    jQuery(main + ' #progress').css('height', secondHeight + 'px');
                }
                jQuery(main + ' #standby').addClass('hidden');
        
                if (jQuery(activeEl + ' .inner-buttons .fl-button.active').length == 0) {
                    jQuery(main + ' #join-btn').addClass('disabled');
                } else {
                    jQuery(main + ' #join-btn').removeClass('disabled');
                    if (window.matchMedia('(min-width: 1046px)').matches) {
                        jQuery(main + ' #progress').css('height', finalHeight + 'px');
                    }
                }
        
                jQuery(main + ' .toggle-jtc .fl-button').removeClass('active');
                jQuery(this).addClass('active');
                jQuery(main + ' .fl-module-photo').addClass('hidden');
                jQuery(activeImg).removeClass('hidden');
                jQuery(main + ' .jtc-content-col').hide();
                jQuery(activeEl).show();
                jQuery(activeEl).removeClass('disabled');
            });
        
            jQuery(main + ' .inner-buttons .fl-button').on('click', function (e) {
                e.preventDefault();
                jQuery(main + ' .inner-buttons .fl-button').removeClass('active');
                jQuery(this).addClass('active');
                jQuery(main + ' .jtc-features-wrapper').hide();
                let activeEl = '#' + jQuery(this).attr('href').replace(/^http?:\/\//, '');
        
                jQuery(activeEl).show();
        
                var homeUrl = window.homeUrl;
        
                // Update the #join-btn href based on class
                if (jQuery(activeEl).hasClass('rw-silver')) {
                    jQuery(main + ' #join-btn a').attr('href', homeUrl + '/club/red-white-wine-silver-club');
                } else if (jQuery(activeEl).hasClass('rw-gold')) {
                    jQuery(main + ' #join-btn a').attr('href', homeUrl + '/club/red-white-wine-gold-club');
                } else if (jQuery(activeEl).hasClass('rw-platinum')) {
                    jQuery(main + ' #join-btn a').attr('href', homeUrl + '/club/red-white-wine-platinum-club');
                } else if (jQuery(activeEl).hasClass('ro-silver')) {
                    jQuery(main + ' #join-btn a').attr('href', homeUrl + '/club/red-wine-silver-club');
                } else if (jQuery(activeEl).hasClass('ro-gold')) {
                    jQuery(main + ' #join-btn a').attr('href', homeUrl + '/club/red-wine-gold-club');
                } else if (jQuery(activeEl).hasClass('ro-platinum')) {
                    jQuery(main + ' #join-btn a').attr('href', homeUrl + '/club/red-wine-platinum-club');
                }
        
                if (jQuery(activeEl).hasClass('not-available')) {
                    jQuery(main + ' #standby').removeClass('hidden');
                    jQuery(main + ' #join-btn').addClass('disabled');
                } else {
                    jQuery(main + ' #join-btn').removeClass('disabled');
                    jQuery(main + ' #standby').addClass('hidden');
                }
                if (window.matchMedia('(min-width: 1046px)').matches) {
                    jQuery(main + ' #progress').css('height', finalHeight + 'px');
                }
            });
        
            jQuery(main + ' #join-btn').on('click', function (e) {
                e.preventDefault(); 
            
                let overlay = jQuery('<div class="join-overlay"><span class="spinner"></span></div>');
                jQuery(this).append(overlay);
            
                jQuery(this).addClass('disabled');
            
                let targetUrl = jQuery(this).find('a').attr('href');
            
                let dataTestId = targetUrl.split('/').pop().toLowerCase(); // Get the last part of the URL and normalize
            
                let originalButtons = jQuery('.c7-btn');
            
                // Get all the buttons with data-testid and normalize their value
                let originalButton = originalButtons.filter(function () {
                    let dataTestIdValue = jQuery(this).data('testid');
            
                    if (!dataTestIdValue) {
                        return false; 
                    }
            
                    // Decode the data-testid value to handle special characters
                    let decodedTestId = decodeURIComponent(dataTestIdValue);
            
                    // Extract the part before '-join-club-button' and normalize it
                    let normalizedTestId = decodedTestId ? decodedTestId.split('-join-club-button')[0]
                        .toLowerCase()          
                        .replace(/&/g, '')      
                        .replace(/\s+/g, '-')   
                        : '';
            
                    // Compare with the part of the URL from href of join-btn (after '/club/')
                    let normalizedUrlPart = dataTestId.split('/').pop().toLowerCase()
                        .replace(/\s+/g, '-')  
                        .replace(/&/g, '');     
            
                    return normalizedTestId === normalizedUrlPart;
                });
            
                if (originalButton.length > 0) {
    
                    const clickEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
            
                    originalButton[0].dispatchEvent(clickEvent);
            
                    e.stopPropagation();
                }

            });
        
        }
            

        //**woocommerce**//
        
        // Woo Buttons
        jQuery('.woocommerce-form-row,.woocommerce-form,.edit-account,.woocommerce-orders-table,.woocommerce-MyAccount-content').addClass('primary-btn');
        jQuery( ".woocommerce-Button,.woocommerce-button,.woocommerce-MyAccount-content .button" ).each(function() {
          jQuery( this ).addClass( "fl-button" );
        });
        
        // Lost Password
        jQuery('.woocommerce-lost-password .woo-my-account-wrapper .woocommerce-notices-wrapper').prependTo('.lost_reset_password');
        
        // My Account Navigation
        var active_menu = jQuery('.woocommerce-MyAccount-navigation-link.is-active a').text()
        var active_class = jQuery('.woocommerce-MyAccount-navigation-link.is-active').attr('class');

        jQuery('.navigation-myaccount-mobile-btn').html( active_menu);
        jQuery('.navigation-myaccount-mobile-btn').addClass( active_class );
        
        jQuery( ".navigation-myaccount-mobile-btn" ).click(function() {
         jQuery('.woocommerce-MyAccount-navigation ul').slideToggle( "slow" );
         jQuery('.woocommerce-MyAccount-navigation').toggleClass('active-menu');
        });
        
        // My Account Orders Page navigation-myaccount-mobile-btn
        jQuery( "#order-filter-btn,.view-all" ).click(function() {
            jQuery(this).next().slideToggle( "slow" );
        });
        jQuery( ".order-date-filter-list div" ).click(function() {
            jQuery('.order-active-filter').html(jQuery(this).text());
            if( jQuery(this).attr('value') == 'today')
                jQuery('.this-week,.this-month,.order-list-container .all').hide( );
            else if( jQuery(this).attr('value') == 'this-week'){
                jQuery('.this-week').show();
                jQuery('.this-month').hide( );
            }
            else if( jQuery(this).attr('value') == 'this-month')
                jQuery('.this-week,.this-month').show( );
            else
                jQuery('.this-week,.this-month,.order-list-container .all').show( );
        });
        
        
        //** Primary button hover Effect ** //
        jQuery("body").append('<svg id="btn-goo" version="1.1"><defs><filter id="goo"><feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10"></feGaussianBlur><feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7" result="goo"></feColorMatrix><feBlend in2="goo" in="SourceGraphic" result="mix"></feBlend></filter></defs></svg>');
        
        jQuery('.primary-btn .fl-button').append('<span class="blob-btn__inner"><span class="blob-btn__blobs"><span class="blob-btn__blob"></span><span class="blob-btn__blob"></span><span class="blob-btn__blob"></span><span class="blob-btn__blob"></span></span></span>')
        
        // change product image when attribute is selected
        // var image_to_show = '';
        // var variations = JSON.parse($(".variations_form").attr("data-product_variations"));
        // if(variations) {
        //     var first_attr = Object.keys(variations[0].attributes)[0];
        //     // when swatch button is clicked
        //     $("ul[data-attribute_name='"+first_attr+"'] li").click(function() {
        //         var choice = $(this).attr("data-value");
        //         var found = false;
        //         // loop variations JSON
        //         for(const i in variations) {
        //             if(found) continue;
        //             if(variations.hasOwnProperty(i)) {
        //                 // if first attribute has the same value as has been selected
        //                 if (choice === variations[i].attributes[Object.keys(variations[0].attributes)[0]]) {
        //                     // change featured image
        //                     image_to_show = variations[i].image_src;
        //                     found = true;
        //                 }
        //             }
        //         }
        //     });
    
        //     // after woo additional images has changed the image, change it again
        //     jQuery(".variations_form").on("wc_additional_variation_images_frontend_image_swap_done_callback", function() {
        //         if(image_to_show.length) {
        //             $(".attachment-shop_single").attr("src", image_to_show).removeAttr("srcset");
        //         }
        //     });
    
        // }

        
    //Document Ready End 
    });    

    // Splash Page cookies
    jQuery(document).ready(function($) {
        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            var domain_name = window.location.host;
            document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
        }
    
        function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        }
    
        if (Boolean(getCookie('popup')) == true) {
            $('.splash-popup-wrapper').addClass('splash-popup-hide');
        } else {
            $('.splash-popup-wrapper').addClass('splash-popup-loaded');
            $("body").css("overflow", "hidden");
            $("#splash-popup__button").on("click", function() {
                setCookie('popup', true, 365);
                $('.splash-popup-wrapper').addClass('splash-popup-hide');
                $("body").css("overflow", "auto");
            });
        }
    });

    jQuery(document).ready(function ($) {
        $(document).on("click", ".FeinWines_product .c7-tab-link", function () {

          $(".FeinWines_product .c7-tab-link").removeClass("active");
          $(".FeinWines_product .c7-tab-content").removeClass("active");
      
          const targetTab = $(this).data("tab");
          $(this).addClass("active");
          $("#" + targetTab).addClass("active");

        });
    });

    // Show/Hide Hero Section for Collections
    jQuery(document).ready(function ($) {
        var currentPath = window.location.pathname;
    
        $('.show-on-wines, .show-on-best-seller, .show-on-current-obsessions, .show-on-merchandise, .show-on-all-time-favorites, .show-on-handpicked').removeClass('show');
    
        if (currentPath.includes('/collection/wines/')) {
            $('.show-on-wines').addClass('show');
        } else if (currentPath.includes('/collection/best-sellers/')) {
            $('.show-on-best-seller').addClass('show');
        } else if (currentPath.includes('/collection/current-obsessions/')) {
            $('.show-on-current-obsessions').addClass('show');
        } else if (currentPath.includes('/collection/merchandise/')) {
            $('.show-on-merchandise').addClass('show');
        } else if (currentPath.includes('/collection/all-time-favorites/')) {
            $('.show-on-all-time-favorites').addClass('show');
        } else if (currentPath.includes('/collection/handpicked-for-your-cellar/')) {
            $('.show-on-handpicked').addClass('show');
        }
    });
    
    // Scroll to the top of the .collection-page section when pagination is clicked
    jQuery(document).ready(function ($) {
        $(document).on("click", ".c7-pagination a", function () {
        setTimeout(function () {
            const targetOffset = $(".collection-page").offset().top - 50; 
            $("html, body").animate({ scrollTop: targetOffset }, 800); 
        }, 100);
        });
    });

      